import { FC } from "react";
import cls from "../../../utils/cls";
import { H2 } from "../../../components/basics";
import classNamePresets from "../../../utils/classNamePresets";
import fwbImg from "../../../assets/images/fwb.svg";

interface HeadingProps {
  title: string;
}

const Heading: FC<HeadingProps> = ({ title }) => {
  return (
    <div className={cls("flex items-center justify-between pb-4")}>
      <H2 className={classNamePresets.mainHeading}>{title}</H2>
      <div className="hidden md:block">
        <img src={fwbImg} className="h-10 md:h-16" alt={"contractor"} />
      </div>
    </div>
  );
};

export default Heading;
